import React, { useCallback, useEffect, useState } from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner,
} from "reactstrap";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Select from "react-select";

import {
    getDashboardSalidas,
    reportTicketPublic,
    resourcesBranch,
    resourcesReports,
} from "../../../helpers/backend_helper";
import PreviewPDF from "../../../helpers/previewPDF";

const UnidadDashboard = () => {
    const { route_slug } = useParams();
    const [route, setRoute] = useState(null);
    const [unit, setUnit] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [type, setType] = useState("arrive");

    useEffect(() => {
        setRoute({});
        setUnit({});
    }, []);

    if (isLoading)
        return (
            <div>
                <div className="maintenance-cog-icon text-primary pt-4 text-center">
                    <i className="mdi mdi-cog spin-right display-3"></i>
                    <i className="mdi mdi-cog spin-left display-4 cog-icon"></i>
                    <p className="text-dark"></p>
                    <h3 className="mt-4">Cargando información de la ruta</h3>
                    <p className="text-dark">Espere un momento por favor</p>
                </div>
            </div>
        );

    if (!route)
        return (
            <p className="text-center py-4">No se encontro información</p>
        );

    if (!unit) return <p className="text-center py-4">No se encontro información de la unidad</p>;

    return (
        <>
            <div className="" style={{ backgroundColor: "#f1f6f9", minHeight: "100vh" }}>
                <div className="px-3">
                    <Container fluid className="pt-4">
                        <Row className="mb-3">
                            <Col md={12}>
                                <h2 className="mb-0">Ruta: {route.name}</h2>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={8}>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Card className="border-0 shadow-sm h-100">
                                            <CardBody className="px-3 py-2">
                                                <div className="d-flex align-items- align-items-center mt-2">
                                                    <div className="flex-fill">
                                                        <div className="d-flex align-items-center justify-content-center bg-warning" style={{ width: "50px", height: "50px", borderRadius: "50%" }}>
                                                            <i className="mdi mdi-bus text-white fs-2"></i>
                                                        </div>
                                                    </div>
                                                    <div className="flex-fill border-end border-1 border-light pe-2">
                                                        <p className="text-uppercase fw-light mb-0"><small>Unidad</small></p>
                                                        <p className="mb-0 fs-4">U-01</p>
                                                    </div>
                                                    <div className="flex-fill text-end px-1">
                                                        <p className="text-uppercase fw-light mb-0"><small>Salida del día</small></p>
                                                        <p className="mb-0 fs-6">#2</p>
                                                    </div>
                                                    <div className="flex-fill text-end">
                                                        <p className="text-uppercase fw-light mb-0"><small>Hora salida</small></p>
                                                        <p className="mb-0 fs-6">09:30am</p>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card className="border-0 shadow-sm h-100">
                                            <CardBody className="px-3 py-1">
                                                <div className="d-flex align-items- align-items-center mt-2">
                                                    <div className="flex-fill border-end border-1 border-light pe-2">
                                                        <p className="text-uppercase fw-light mb-0"><small>Conductor</small></p>
                                                        <p className="mb-0 fs-4 lineHeight1">Juan Pérez asdasd</p>
                                                    </div>
                                                    <div className="flex-fill text-end px-1">
                                                        <p className="text-uppercase fw-light mb-0"><small>Ramal</small></p>
                                                        <p className="mb-0 lineHeight1"><small>Nombre del ramal A</small></p>
                                                    </div>
                                                    <div className="flex-fill text-end px-1">
                                                        <p className="text-uppercase fw-light mb-0"><small>Destino</small></p>
                                                        <p className="mb-0 lineHeight1"><small>Nombre del destino A</small></p>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Card className="border-0 shadow-sm h-100">
                                            <CardBody className="px-3 py-1">
                                                <div className="d-flex align-items- align-items-center mt-2">
                                                    <div className="flex-fill border-end border-1 border-light pe-2">
                                                        <p className="text-uppercase fw-light mb-1"><small>Pasajeros abordo</small></p>
                                                        <p className="mb-0 fs-4 lineHeight1">120</p>
                                                    </div>
                                                    <div className="flex-fill text-end px-1">
                                                        <p className="text-uppercase fw-light mb-1"><small>Capacidad</small></p>
                                                        <p className="mb-0 lineHeight1"><span>150</span></p>
                                                    </div>
                                                    <div className="flex-fill text-end px-1">
                                                        <p className="text-uppercase fw-light mb-1"><small>Ocupación</small></p>
                                                        <p className="mb-0 lineHeight1"><span>80%</span></p>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Card className="border-0 bg-danger h-100 text-white">
                                            <CardBody className="px-3 py-3 text-center">
                                                <i className="text-white fas fa-exclamation-triangle fs-1"></i>
                                                <h1 className="text-white lineHeight1 text-uppercase py-3">Atrasado</h1>
                                                <hr className="border-light" />
                                                <p className="text-uppercase lineHeight1"><small>Diferencia</small></p>
                                                <p className="lineHeight1 fs-1 fw-bold">+ 03:20</p>
                                                <p className="lineHeight1 mb-0"><small>min</small></p>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Card className="border-0 shadow-sm h-100">
                                            <CardBody className="px-3 py-1">
                                                <div className="d-flex align-items- align-items-center mt-2">
                                                    <div className="flex-fill border-end border-1 border-light pe-2">

                                                    </div>
                                                    <div className="flex-fill text-center px-1">
                                                        <p className="fw-light mb-0"><span className="fs-1">28</span><span className="ps-2">km/h</span></p>
                                                        <p className="text-uppercase mb-0 lineHeight1 text-success"><small>velocidad ok</small></p>
                                                    </div>
                                                    <div className="flex-fill text-start px-1">

                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={4}>
                                <Card className="border-0 shadow-sm">
                                    <CardBody>
                                        <p className="card-title mb-0 pb-0">Próximas paradas</p>
                                        <hr className="my-1" />
                                        <div className="border-start border-1 border-light ps-2 mt-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill text-start px-1">
                                                    <p className="text-uppercase fw-light mb-0"><small>Parada</small></p>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="text-uppercase fw-light mb-0"><small>Hora llegada</small></p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 1</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">
                                                        <Badge color="success me-2">(+1 min)</Badge>
                                                        10:00am
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 2</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">
                                                        <Badge color="danger me-2">(+5 min)</Badge>
                                                        10:15am
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 3</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">
                                                        <Badge color="danger me-2">(-5 min)</Badge>
                                                        10:30am
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 4</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">
                                                        <Badge color="info me-2">(próxima)</Badge> 10:45am
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 5</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">11:07am</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 6</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">11:17am</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="flex-fill">
                                                    <small><i className="fas fas fa-circle text-primary me-1"></i></small>
                                                    <span className="mb-0 fs-6">Nombre de la parada 7</span>
                                                </div>
                                                <div className="flex-fill text-end px-1">
                                                    <p className="mb-0 fs-6 fw-bold">11:30am</p>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </div>
        </>
    );
};

export default UnidadDashboard;
